import { RefObject, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Dropdown.module.css';

import { StringByKey } from '../../types/common';
import Input from '../Input';
import { isOfType } from '../../utils/typeGuard';
import { isMobile } from '../../utils/util';
import {
  ACTIVITY_LIBRARIES,
  CREATE_FOLDER,
  EMAIL,
  FILE_DATA,
  FILE_UPLOAD,
  GRADE,
  LINK_REGISTRATION,
  NICKNAME,
  SCHOOL_GRADE,
  SCHOOL_NAME,
  SUBJECT,
} from '../../constants';

interface DropdownProps {
  name: string;
  classnames?: string[];
  type?: string;
  list: string[];
  clickHandlers: ((params: any) => void)[];
  isOpen: boolean;
  button: RefObject<HTMLElement>;
  backdropHandler: () => void;
  data?: any;
  sortOrder?: 'asc' | 'desc';
}

export default function Dropdown({
  name,
  classnames,
  type,
  list,
  clickHandlers,
  isOpen,
  button,
  backdropHandler,
  data,
  sortOrder,
}: DropdownProps) {
  const cx = classNames.bind(styles);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClick = (name: string, i: number) => {
    if (name === 'file') return;
    if (clickHandlers.length > 1) {
      clickHandlers[i] && clickHandlers[i](name);
    } else {
      clickHandlers[0](name);
    }
  };

  let buttonTexts: StringByKey = {};

  switch (name) {
    case 'sortType':
    case 'options':
      buttonTexts = data;
      break;
    case 'dataUpload':
      buttonTexts = {
        file: FILE_UPLOAD,
        link: LINK_REGISTRATION,
        dataFile: FILE_DATA,
      };
      break;
    case 'columnSelection':
      buttonTexts = {
        alias: NICKNAME,
        schoolTypeNm: SCHOOL_GRADE,
        schoolNm: SCHOOL_NAME,
        gradeTypeNm: GRADE,
        email: EMAIL,
        subjectTypeNm: SUBJECT,
      };
      break;
    case 'libraryType':
      buttonTexts = ACTIVITY_LIBRARIES;
      break;
    default:
      break;
  }

  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (
        isOfType<HTMLElement>(target, 'nodeName') &&
        !dropdownRef?.current?.contains(target) &&
        !button.current?.contains(target)
      ) {
        const isOpenCopyrightModal = target.closest('.uploadCopyright');
        !isOpenCopyrightModal && backdropHandler();
      }
    };
    window.addEventListener('click', clickHandler);
    document
      .querySelector('.simplebar-content-wrapper')
      ?.addEventListener('scroll', backdropHandler);

    return () => {
      window.removeEventListener('click', clickHandler);
      document
        .querySelector('.simplebar-content-wrapper')
        ?.removeEventListener('scroll', backdropHandler);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={cx('dropdown_wrap', classnames)} ref={dropdownRef}>
      <div className={cx('dropdown_menu')}>
        <ul className={cx('dropdown_list')}>
          {/* {name === 'dataUpload' && (
            <li>
              <button type="button" className={cx('btn')}>
                <span className={cx('svg_i', 'folder_mini')}></span>
                <span>{CREATE_FOLDER}</span>
              </button>
            </li>
          )} */}
          {list.map((menu, i) => (
            <li
              key={menu}
              className={cx({
                dividing:
                  (isMobile && menu === 'edit') ||
                  (!isMobile &&
                    menu === 'asc') /* || (name === 'dataUpload' && i === 0) */,
              })}
            >
              <button
                type="button"
                className={cx('btn', {
                  on: type === menu || sortOrder === menu,
                })}
                onClick={() => handleClick(menu, i)}
              >
                {name === 'dataUpload' && (
                  <span className={cx('svg_i', menu)}></span>
                )}
                <span>{buttonTexts[menu]}</span>
                {(menu === 'file' || menu === 'dataFile') && (
                  <>
                    <label
                      htmlFor={
                        menu === 'file' ? 'library_upload' : 'uploadFile'
                      }
                    ></label>
                    <Input
                      type="file"
                      id={menu === 'file' ? 'library_upload' : 'uploadFile'}
                    />
                  </>
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
